import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormArray } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import * as moment from 'moment';

import { GlobalFunctionsService } from 'src/app/ceq/common/functions/global-functions.service';
import { InventoryCutService } from '../inventory-cut.service';
import { CalendarService } from 'src/app/ceq/configuration/calendar/calendar.service';
import { SettingsService } from 'src/app/core/settings/settings.service';
import { PurchaseService } from 'src/app/ceq/purchase/purchase.service';

import { InventoryMovementDetail } from 'src/app/ceq/common/models/InventoryMovementDetail.Model';
import { InventoryMovement } from 'src/app/ceq/common/models/InventoryMovement.Model';
import { CeveCutDetail } from 'src/app/ceq/common/models/CeveCutDetail.Model';
import { CeveCutStatus } from 'src/app/ceq/common/models/CeveCutStatus.Enum';
import { UserLogin } from 'src/app/ceq/common/models/UserLogin.Model';
import { Calendar } from 'src/app/ceq/common/models/Calendar.Model';
import { CeveCut } from '../../../common/models/CeveCut.Model';
import { Ceve } from '../../../common/models/Ceve.Model';
import { isNumber } from 'lodash';

interface movObj {
  Movement: InventoryMovement;
  Details: Array<InventoryMovementDetail>;
}

interface RowCutList{
  CutId: string;
  Line: number;
  Item: string;
  OldQty: number;
  NewQty: number;
}

@Component({
  selector: 'app-preinventory-ceve',
  templateUrl: './preinventory-ceve.component.html',
  styleUrls: ['./preinventory-ceve.component.scss']
})
export class PreinventoryCeveComponent implements OnInit {
  constructor(
    private router: Router,
    private calendarServ: CalendarService,
    private settings: SettingsService,
    private purchaseService: PurchaseService,
    private inventoryCutService: InventoryCutService,
    private globalFunctionService: GlobalFunctionsService
  ) {}

  //Visuales:
  firstChangeVersion: Date = new Date('2022-10-09'); //version de inventario inicial, entradas y salidas del SP7. Ultimo inventario antes de esta version: 8 de octubre
  secondChangeVersion: Date = new Date('2022-10-29'); //version de inventario inicial, entradas y salidas del SP8. Ultimo inventario antes de esta version: 5 de noviembre
  thirdChangeVersion: Date = new Date('2023-05-10'); //version de inventario inicial, entradas y salidas del SP9. Ultimo inventario antes de esta version: 10 de Mayo

  //Property
  cutVersion: number = 1;
  datepipe: DatePipe = new DatePipe('en-US');
  unitId: number;
  ceveCutId: string;
  userLogin: UserLogin;
  hasSelected: boolean;
  ceve: Ceve[] = [new Ceve()];
  actualDate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
  selectedDate: string;
  previousDate: string;
  initialDate: any;
  finalDate: any;

  startDate = this.datepipe.transform(
    new Date().setDate(new Date().getDate() - 40),
    'yyyy-MM-dd'
  );
  keyword = 'CeveName';
  signs: {
    dispatcherReciverSign: string;
    managerSignature: string;
    supervisorSignature: string;
    dispatcherReciverComment: string;
    managerComment: string;
    supervisorComment: string;
  };
  isDispatcherReciverSign: boolean;
  isManagerSign: boolean;
  isSupervisorSign: boolean;
  signCompleted: boolean;
  isSaving: boolean;
  isClosing: boolean;
  isOpening: boolean;
  disableButton: boolean;
  isLoading: boolean;
  currentYear = new Date().getFullYear();
  listDateAvalible: Calendar[] = [];
  lastEvent: Calendar;
  status: CeveCutStatus;
  isCeveAdmn: boolean;
  isCeveSupervisor: boolean;
  actualDateTime: string;
  isDateTimeRangeValid: boolean = false;
  asSum: any[] = [];
  isNodeChild: boolean = false;
  isNodeLeader: boolean = false;
  modifiedAt: string;
  canCreate = true;
  //Variables for new cuts
  cutCeveData: any[] = [];
  teoricoDif: any[] = [];
  rowCutList: RowCutList[] = [];
  rowAdjustList: RowCutList[] = [];

  //signsActivities
  signActDispatcherReceiver: boolean = false;
  signActAdministrator: boolean = false;
  signActSuppervisorDisp: boolean = false;

  persistentCreatedAt: Date = undefined;
  persistentCreatedBy: string = '';

  //Product type titles
  containerData: Array<{
    ContainerId: string;
    ContainerDescription: string;
    ContainerName: string;
  }> = [];

  //set arrays at one form
  inventoryForm = new FormGroup({
    physicalInventory: new FormArray([]),
    physicalInventoryfromLapsed: new FormArray([]),
    couponInventory: new FormArray([]),
    promissoryNoteInventory: new FormArray([]),
    totalInventoryVehicle: new FormArray([]),
    rtmVehicles: new FormArray([]),
    routeCharges: new FormArray([]),
    stockAllocation: new FormArray([]),
    vanLoadRejection: new FormArray([]),
    totalPhysicalInventory: new FormArray([]),
    logisticsBalance: new FormArray([]),
    diffNotAttributable: new FormArray([]),
    diffAttributable: new FormArray([]),
  });  

  ngOnInit(): void {
    this.initialDate = moment(new Date()).format('yyyy-MM-DD');
    this.finalDate = moment(new Date()).format('yyyy-MM-DD');
    this.globalFunctionService.hasFSBRPending();
    this.globalFunctionService.canOperate();
    this.InititalizeData();
  }

  InititalizeData() {
    this.asSum = [];
    this.isLoading = false;
    this.getEvents();
    this.ceveCutId = '';
    this.signs = {
      dispatcherReciverSign: '',
      managerSignature: '',
      supervisorSignature: '',
      dispatcherReciverComment: '',
      managerComment: '',
      supervisorComment: '',
    };
    this.hasSelected = false;
    this.signCompleted = false;
    this.status = CeveCutStatus.NEW;
    this.userLogin = this.settings.getUser();
    var activities = this.settings.getUserAccess();
    this.isCeveSupervisor = false;
    this.isCeveAdmn = false;
    if (activities.find((x) => x == 'SUPCEVE')) {
      this.isCeveSupervisor = true;
    }
    if (activities.find((x) => x == 'ADMCEVE')) {
      this.isCeveAdmn = true;
    }
    if (activities.includes('FICADRC')) {
      this.signActDispatcherReceiver = true;
    }
    if (activities.includes('FICAACE')) {
      this.signActAdministrator = true;
    }
    if (activities.includes('FICASDC')) {
      this.signActSuppervisorDisp = true;
    }

    this.inventoryCutService
      .getCevesByUser(this.userLogin.Id)
      .subscribe((ceve) => (this.ceve = ceve));
  }

  getEvents(): void {
    this.calendarServ.getCalendarCutEvents().subscribe(
      (events: Calendar[]) => {
        this.listDateAvalible = events.sort((b,a)=>new Date(a.StartAt).getTime() - new Date(b.StartAt).getTime());
        var dates = events.map((x) => x.StartAt);
        var newDate = dates.reduce((a, b) => (a > b ? a : b));
        this.lastEvent = events.find((x) => x.StartAt == newDate);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  async getCentralTime(): Promise<Date> {
    var centralDate: Date = new Date();
    await this.inventoryCutService
      .getCentralTime()
      .toPromise()
      .then((x) => {
        centralDate = x;
      })
      .catch(() => {
        this.globalFunctionService.messageToast(`No se ha podido obtener la hora central.`, 'warning');
        return;
      });
    return centralDate;
  }

  /**
   * Obtiene el preinventario de un ceve y si no existe para la fecha dada pregunta si se desea generar
   * @param item 
   * @returns 
   */
  async selectEvent(item?) {
    this.updateTime();
    console.log(await this.getCentralTime());
    console.log(this.selectedDate);
    console.log(this.actualDate);

    this.cutVersion = 4;
    this.isDateTimeRangeValid = true;
    if(this.selectedDate > this.actualDate){
      this.canCreate = false;
      this.globalFunctionService.messageToast(`No se puede crear una caratula para fechas posteriores.`, 'warning');
      this.canCreate = true;
      return;
    }
    if (!item) {
      if (this.unitId == undefined) {
        return;
      }
    }else{
      this.unitId = item.UnitId;
    }
    if (this.selectedDate == null || this.selectedDate == undefined) {
      return;
    }
    var selectedDateIndex = this.listDateAvalible.indexOf(
      this.listDateAvalible.find(
        (x) => x.StartAt.toString() == this.selectedDate
      )
    );
    this.previousDate =
       selectedDateIndex >= (this.listDateAvalible.length - 1)
         ? (this.datepipe.transform(this.inventoryCutService.getPreviousDate(new Date(this.selectedDate)), 'yyyy-MM-ddTHH:mm'))
         : this.listDateAvalible[selectedDateIndex + 1].StartAt.toString();
    this.isLoading = true;
    this.hasSelected = false;

    //Validación de centro de ventas activo
    await this.inventoryCutService.getCeveActive(this.unitId).toPromise().then(async (isActive) => {
      if (!isActive) {
        await this.globalFunctionService.messageBimbo(`El nodo seleccionado no se encuentra activo.`, 'error','');
        return;
      }
    });

    //Se valida si es nodo hijo o líder
    await this.inventoryCutService.isNodeLeader(this.userLogin.Org, this.unitId).toPromise().then((x: boolean) => {
      this.isNodeLeader = x;
    });
    await this.inventoryCutService.isNodeChild(this.userLogin.Org, this.unitId).toPromise().then((nc: boolean) => {
      this.isNodeChild = nc;
    });

    //Se obtienen los contenedores del ceve
    await this.inventoryCutService.getCeveByContainers(this.unitId).toPromise().then((x) => {
      this.containerData = [];
      x.forEach((element) => {
        this.containerData.push({
          ContainerDescription: element.ContainerDescription.split('.', 1),
          ContainerName: element.ContainerCode,
          ContainerId: element.ContainerId,
        });
      });
    });

    //Mensaje de espera
    await this.globalFunctionService.messageBimbo(`...por favor espere`, 'loading', 'Actualizando información...');

    await this.inventoryCutService.getCevePreCut2(this.unitId,this.datepipe.transform(this.selectedDate, 'yyyy-MM-dd')).toPromise().then(async (data) => {
      if(data != null && data != undefined && data.CeveCutDetail.length > 0){
        this.cutCeveData = data.CeveCutDetail.filter((x) => x.LINE != 26);
        this.teoricoDif = data.CeveCutDetail.filter((x) => x.LINE == 26);
        this.existInventory(data.CeveCutDetail, data.CeveCut);
        Swal.close();
        this.isLoading = false;
      }else{
        Swal.close();
        this.isLoading = false;
        if(this.selectedDate !== this.actualDate){
          this.globalFunctionService.messageToast(`No se puede crear una caratula para esta fecha.`, 'warning');
          this.canCreate = true;
          return;
        }
        const confirm = await this.warningApply(`No existe un corte para la fecha seleccionada ¿Desea generar el corte para la fecha ${this.selectedDate}?`);
        if (!confirm) {
          Swal.close();
          this.isSaving = false;
          return;
        }

        this.isLoading = true;
        //Mensaje de espera
        await this.globalFunctionService.messageBimbo(`...por favor espere`, 'loading', 'Generando carátula de preinventario...');

        this.inventoryCutService.generateCeveCutSP(this.unitId,this.previousDate,this.selectedDate,true).toPromise().then((resp) => {
            Swal.close();
            this.isLoading = false;
            this.selectEvent();
        }).catch(async (err: HttpErrorResponse) => {
            this.isLoading = false;
            console.log(err);
            await this.globalFunctionService.messageBimbo(`No se pudo generar el corte de preinventario`, 'error', '');
            return;
        });
      }
    });
    //this.inventoryForm.reset();
    //this.inventoryForm.disable();      
  }

  /**
   * Valida si existe un inventario para la fecha y ceve seleccionado
   * @param ceveCutDetail 
   * @param ceveCut 
   */
  existInventory(ceveCutDetail: Array<CeveCutDetail>, ceveCut: CeveCut) {
    this.signs.dispatcherReciverSign = ceveCut.DispatcherReciverSign;
    this.signs.managerSignature = ceveCut.ManagerSign;
    this.signs.supervisorSignature = ceveCut.SupervisorSign;
    this.signs.dispatcherReciverComment = ceveCut.DispatcherReciverComment;
    this.signs.managerComment = ceveCut.ManagerComment;
    this.signs.supervisorComment = ceveCut.SupervisorComment;
    this.isManagerSign = ceveCut.ManagerSign != '';
    this.isDispatcherReciverSign = ceveCut.DispatcherReciverSign != '';
    this.isSupervisorSign = ceveCut.SupervisorSign != '';
    this.signCompleted =
      this.isManagerSign &&
      this.isDispatcherReciverSign &&
      this.isSupervisorSign;
    if(this.selectedDate < this.actualDate){
      this.status = CeveCutStatus.CLOSED;
    }else{
      this.status = ceveCut.Status;
    }

    this.ceveCutId = ceveCut.CeveCutId;
    this.cutVersion = ceveCut.Version;
    this.persistentCreatedAt = ceveCut.CreatedAt;
    this.persistentCreatedBy = ceveCut.CreatedBy;
    this.modifiedAt = this.datepipe.transform(
      ceveCut.ModifiedAt,
      'dd/MM/yyyy - HH:mm'
    );

    this.asSum = [];
    if (
      !this.isCeveAdmn ||
      this.status == CeveCutStatus.CLOSED ||
      this.status == CeveCutStatus.PUBLISHED ||
      this.status == CeveCutStatus.INCOMPLETESIGNED ||
      this.status == CeveCutStatus.LAPSED ||
      this.isNodeChild
    ) {
      this.inventoryForm.disable();
    }
    this.hasSelected = true;
    this.disableButton = true;
    this.isLoading = false;
}

/**
 * 
 * @param close 
 * @returns 
 */
async saveOrEdit(close: boolean) {
    this.isSaving = true;
    if (this.status == CeveCutStatus.SAVED) {
      if (close) {
        this.isSaving = false;
        this.isClosing = true;
        const confirm = await this.warningApply(
          `¿Desea cerrar el corte?. Los registros no podrán ser editados.`
        );
        if (!confirm) {
          Swal.close();
          this.isClosing = false;
          return;
        }
      } else {
        const confirm = await this.warningApply(`¿Desea guardar el corte?`);
        if (!confirm) {
          Swal.close();
          this.isSaving = false;
          return;
        }
      }
    }
    await this.globalFunctionService.messageBimbo(`Por favor espere`, 'loading', 'En proceso...');
    this.updateTime();

    if (close) {
      this.editCeveCut(CeveCutStatus.CLOSED, []);
    } else {
      this.editCeveCut(CeveCutStatus.SAVED, []);
    }
  }

  /**
   * 
   * @param status 
   * @param signs 
   */
  async editCeveCut(status: CeveCutStatus, signs: any[]) {
    let dataToSave: CeveCut = new CeveCut();
    var userName = this.settings.getUser().Name;
    var stringDate = this.datepipe.transform(
      await this.getCentralTime(),
      'yyy,MM,dd'
    );
    var date = new Date(stringDate);
    dataToSave.Org = this.userLogin.Org;
    dataToSave.UnitId = this.unitId;
    dataToSave.DispatcherReciverSign = this.signs.dispatcherReciverSign;
    dataToSave.ManagerSign = this.signs.managerSignature;
    dataToSave.SupervisorSign = this.signs.supervisorSignature;
    dataToSave.DispatcherReciverComment = this.signs.dispatcherReciverComment;
    dataToSave.ManagerComment = this.signs.managerComment;
    dataToSave.SupervisorComment = this.signs.supervisorComment;
    dataToSave.Status = status;
    dataToSave.CeveCutId = this.ceveCutId;
    dataToSave.ModifiedAt = new Date(this.actualDateTime);
    dataToSave.ModifiedBy = this.userLogin.Name;
    dataToSave.CreatedAt =
      this.persistentCreatedAt != undefined
        ? this.persistentCreatedAt
        : await this.getCentralTime();
    dataToSave.CreatedBy =
      this.persistentCreatedBy != ''
        ? this.persistentCreatedBy
        : this.userLogin.Name;

    if (signs.length > 0) {
      if (signs[0] == 'isDispatcherReciverSign') {
        dataToSave.DispatcherReciverSign = signs[1];
      } else if (signs[0] == 'isManagerSign') {
        dataToSave.ManagerSign = signs[1];
      } else if (signs[0] == 'isSupervisorSign') {
        dataToSave.SupervisorSign = signs[1];
      }
    }

    dataToSave.CeveCutDay = this.datepipe.transform(
      this.selectedDate,
      'yyyy-MM-dd'
    );

    var dataSend: { ceveCut: CeveCut; ceveCutDetail: Array<RowCutList> } = {
      ceveCut: dataToSave,
      ceveCutDetail: this.rowCutList
    };

    this.inventoryCutService.saveCevePreCut(dataSend).toPromise().then((x) => {
      this.rowCutList = [];
      this.selectEvent();
      Swal.close();
      this.isSaving = false;
      this.isClosing = false;
      this.globalFunctionService.messageToast(`Carátula de inventario guardada.`, 'success');
    }).catch((err: HttpErrorResponse) => {
      this.rowCutList = [];
      console.log(err);
      Swal.close();
      this.isSaving = false;
      this.isClosing = false;
      this.globalFunctionService.messageToast(`No se pudo guardar el inventario.`, 'error');
    });
  }
    
  async saveSigns(sign: string) {
    await this.purchaseService.getAttachmentList('inventory-ceve',this.ceveCutId).toPromise().then(async (list) => {
      if(list == null || list == undefined){
        this.globalFunctionService.messageToast(`No puede firmar si el validador no registra una evidencia.`, 'warning');
        console.log(list);
        return;
      }else{
        const confirm = await this.warningApply(
          `¿Desea firmar el corte?. Al ingresar la tercer firma el corte será publicado.`
        );
        if (!confirm) {
          Swal.close();
          this.isSaving = false;
          return;
        }
        await this.globalFunctionService.messageBimbo(`Por favor espere`, 'loading', 'En proceso...');
        this.updateTime();
        this.isSaving = true;
        var signInfo = `${this.userLogin.Name}|${
          this.userLogin.Email != '' ? this.userLogin.Email : ''
        }|Fecha: ${this.actualDate}`;
        this.editCeveCut(CeveCutStatus.INCOMPLETESIGNED, [sign, signInfo]);
      }
    });
  }

  print(): void {
    window.print();
  }

  async updateTime() {
    this.actualDateTime = this.datepipe.transform(
      await this.getCentralTime(),
      'yyyy-MM-ddTHH:mm:ss'
    );
  }

  toggleGroupCollapsed(row: any){
    this.cutCeveData.filter(x => x.GROW == row.GROW).forEach(x => x.GROUPED = !x.GROUPED);
  }

  async warningApply(message: string): Promise<boolean> {
    const result = await this.globalFunctionService.messageBimbo(message, 'question1', '');
    return result;
  }

  /**
   * Genera el arreglo de valores a registrar
   * @param row 
   * @param item 
   * @param qty 
   */
  setValue(row: any, item: any, qty: number){
    qty = Number(qty);
    if(qty < 0 || row[item] == qty){
      console.log('No se puede guardar un valor negativo o el mismo valor');
      return;
    }

    // Se agrega el valor receien cambiado al listado de cambios a guardar
    this.addRowCut(row, item, qty);

    if(this.cutVersion <= 3){
      // Se calcula la Existencia total en Vehículos
      this.calculaExistenciaTotalVehiculos_v3(row, item);
      // Se calcula el inventario físico total
      this.calculaInvFisicoTotal_v3(row, item);
      // Se calcula el equipo cobrado a colaboradores
      this.calculaEquipoCobrado_v3(row, item);
      // Se calcula la diferencia de inventario
      this.calculaDiferenciaInventarioTotales_v3(row, item);
    }
    if(this.cutVersion == 4){
      // Se calcula el inventario físico de CEVE
      this.calculaInvFisicoCeve_v4(row, item);
      // Se calcula el inventario físico total
      this.calculaInvFisicoTotal_v4(row, item);
      // Se calcula la diferencia de inventario
      this.calculaDiferenciaInventarioTotales_v4(row, item);
    }
    
    //console.log(this.rowCutList);
  }

  /**
   * Calcula la existencia total de vehículos
   * @param row 
   * @param item 
   */
  calculaExistenciaTotalVehiculos_v3(row: any, item: number){
    let rowsCount = this.cutCeveData.filter((x) => [18, 19, 5, 6, 7, 8, 31, 32].includes(x.LINE));
    let total: number = 0;
    rowsCount.forEach(x => {
        total += x.LINE == 8 ? Number(x[item]) * -1 : Number(x[item]);
        //console.log(total, x[item]);
    });
    this.cutCeveData[4][item] = total;

    this.addRowCut(this.cutCeveData[4], item, total);
  }

  /**
   * Calcula el inventario físico total
   */
  calculaInvFisicoTotal_v3(row: any, item: number){
    let rowsCount = this.cutCeveData.filter((x) => [0, 1, 2, 4, 20].includes(x.LINE));
    let total: number = 0;
    rowsCount.forEach(x => {
        total += Number(x[item]);
        //console.log(total, x[item]);
    });
    this.cutCeveData[15][item] = total;

    this.addRowCut(this.cutCeveData[15], item, total);
  }

  /**
   * Calcula el equipo cobrado a colaboradores
   * @param row 
   * @param item 
   */
  calculaEquipoCobrado_v3(row: any, item: number){
    let rowsCount = this.cutCeveData.filter((x) => [27, 28, 29, 33].includes(x.LINE));
    let total: number = 0;
    rowsCount.forEach(x => {
        total += Number(x[item]);
        //console.log(total, x[item]);
    });
    this.cutCeveData[16][item] = total;

    this.addRowCut(this.cutCeveData[16], item, total);
  }

  /**
   * Calcula la diferencia de inventario version 3
   * @param row 
   * @param item 
   */
  calculaDiferenciaInventarioTotales_v3(row: any, item: number){
    let rowsFisicoTotal = this.cutCeveData.find(x => x.LINE == 9);
    let rowsTeorico = this.cutCeveData.find(x => x.LINE == 13);
    let rowsSaldosAS = this.cutCeveData.find(x => x.LINE == 19);
    let total: number = 0;
    total = Number(rowsFisicoTotal[item]) - (Number(rowsTeorico[item]) + Number(rowsSaldosAS[item]));

    this.cutCeveData[29][item] = total; // Diferencia de inventario
    this.addRowCut(this.cutCeveData[29], item, total);

    let rowsAjusteCompulsas = this.cutCeveData.find(x => x.LINE == 35);
    let dif: number = Number(rowsAjusteCompulsas[item]) + total;
    this.cutCeveData[31][item] = dif; // Diferencias netas
    this.addRowCut(this.cutCeveData[31], item, dif);

    let total2: number = 0;
    total2 = Number(rowsFisicoTotal[item]) -  Number(rowsSaldosAS[item]);
    this.cutCeveData[32][item] = total2; // Inventario de cierre
    this.addRowCut(this.cutCeveData[32], item, total2);
  }

  /**
   * Calcula el inventario físico de CEVE
   * @param row 
   * @param item 
   */
  calculaInvFisicoCeve_v4(row: any, item: number){
    let rowsCount = this.cutCeveData.filter((x) => [37, 38, 39].includes(x.LINE));
    let total: number = 0;
    rowsCount.forEach(x => {
        total += Number(x[item]);
        //console.log(total, x[item]);
    });
    this.cutCeveData[0][item] = total;

    this.addRowCut(this.cutCeveData[0], item, total);
  }

  /**
   * Calcula el inventario físico total version 4
   */
  calculaInvFisicoTotal_v4(row: any, item: number){
    let rowsCount = this.cutCeveData.filter((x) => [0, 1, 2, 18, 31, 20].includes(x.LINE));
    let total: number = 0;
    rowsCount.forEach(x => {
        total += Number(x[item]);
        //console.log(total, x[item]);
    });
    this.cutCeveData[12][item] = total;

    this.addRowCut(this.cutCeveData[12], item, total);
  }

    /**
   * Calcula la diferencia de inventario version 4
   * @param row 
   * @param item 
   */
    calculaDiferenciaInventarioTotales_v4(row: any, item: number){
      let rowsFisicoTotal = this.cutCeveData.find(x => x.LINE == 9);
      let rowsTeorico = this.cutCeveData.find(x => x.LINE == 13);

      let total: number = 0;
      total = Number(rowsFisicoTotal[item]) - Number(rowsTeorico[item]);
  
      //this.cutCeveData[74][item] = total; // Diferencia de inventario
      let index = this.cutCeveData.findIndex(x => x.LINE == 14);
      this.cutCeveData[index][item] = total; // Diferencia de inventario
      this.addRowCut(this.cutCeveData[index], item, total);
  
      let total2: number = 0;
      total2 = Number(rowsTeorico[item]) +  total;
      //this.cutCeveData[75][item] = total2; // Inventario de cierre
      index = this.cutCeveData.findIndex(x => x.LINE == 30);
      this.cutCeveData[index][item] = total2; // Inventario de cierre
      this.addRowCut(this.cutCeveData[index], item, total2);
    }

  /**
   * Agrega una fila al corte para enviar a guardar
   */
  addRowCut(row: any, item: any, qty: number){
    if(row[item] == null || row[item] == undefined || !isNumber(row[item])){
      row[item] = 0;
    }
    if(qty == null || qty == undefined || !isNumber(qty)){
      qty = 0;
    }
    let exist = this.rowCutList.find(x => x.Line == row.LINE && x.Item == item);
    let r = this.cutCeveData.find(x => x.LINE == row.LINE);
    r[item] = qty;
    if(exist != null){
      exist.NewQty = qty;
    }else{
      this.rowCutList.push({
        CutId: row.CUTID,
        Line: row.LINE,
        Item: item,
        OldQty: row[item],
        NewQty: qty
      });
    }
    console.log(this.rowCutList);
  }
}